import { AppFrontendRoute } from '@deltasierra/frontend-routing-app-frontend';
import { QueryParameter, RouterOrigins } from '@deltasierra/frontend-routing-core';
import { assertNever } from '@deltasierra/type-utilities';
import { useEffect } from 'react';
import { BuildableTemplateType } from '../../../../../../../__graphqlTypes/globalTypes';
import { useAppFrontendRouter } from '../../../../../common/hooks/useAppFrontendRouter';
import { ValidatedTemplate } from './validated-template';

function getPublishPathForTemplateType(
    templateType?: BuildableTemplateType,
): AppFrontendRoute.PublishEmail | AppFrontendRoute.PublishMedia {
    return templateType === BuildableTemplateType.media ? AppFrontendRoute.PublishMedia : AppFrontendRoute.PublishEmail;
}

type UseUpdateUrlForValidTemplateOptions = {
    clientId?: string | null;
    locationId?: string | null;
    setUrl: (url: string) => void;
    template: ValidatedTemplate | null;
};

export function useUpdateUrlForValidTemplate({
    clientId,
    locationId,
    setUrl,
    template,
}: UseUpdateUrlForValidTemplateOptions): void {
    const frontendRouter = useAppFrontendRouter();

    useEffect(() => {
        if (!template) {
            return;
        }
        switch (template.type) {
            case 'BuilderTemplate':
                setUrl(`${window.location.origin}/contentBuilder?template=${template.id}`);
                return;
            case 'BuildableTemplate': {
                if (!frontendRouter || !clientId || !locationId) {
                    return;
                }
                const publishRoute = getPublishPathForTemplateType(template.templateType);
                const publishUrl = frontendRouter.get(publishRoute, {
                    [QueryParameter.ClientId]: clientId,
                    [QueryParameter.LocationId]: locationId,
                    [QueryParameter.Origin]: RouterOrigins.OLD_TEMPLATE_GALLERY,
                    [QueryParameter.TemplateId]: template.id,
                });
                setUrl(publishUrl);
                return;
            }
            default:
                // eslint-disable-next-line consistent-return
                return assertNever(template);
        }
    }, [clientId, frontendRouter, locationId, setUrl, template]);
}
